import React from "react";
import { Box, Flex } from "theme-ui";
import { Button } from "./PSY/Button";

import { Dialog } from "./Dialog";

type RetryDialogProps = {
  title: string;
  cancelLabel?: string;
  retryLabel?: string;
  onCancel: () => void;
  onRetry: () => void;
};

export const RetryDialog: React.FC<RetryDialogProps> = ({
  title,
  cancelLabel,
  onCancel,
  retryLabel,
  onRetry,
  children
}) => (
  <Dialog title={title} cancelLabel={cancelLabel} onCancel={onCancel}>
    <Box sx={{ p: [3, 4] }}>{children}</Box>
    <Flex
      sx={{
        p: [3, 4],
        borderTop: 1,
        borderColor: "muted",
        justifyContent: "flex-end",
        flexDirection: ["column", "row"],
        alignItems: "center"
      }}
    >
      <Button
        onSubmit={onCancel}
      >
        {cancelLabel || "Cancel"}
      </Button>
      <Button onSubmit={onRetry}>
        {retryLabel || "Retry"}
      </Button>
    </Flex>
  </Dialog>
);
